import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import { debounce } from "lodash";


// Step Navigation Component
const StepNavigation = ({ steps = [], completeAndNext, next, preview, finish, exit, moduleTitle = "", moduleCompleted = false }) => {
  const [stepProgressWidth, setStepProgressWidth] = useState(0);
  const [loadingFinish, setLoadingFinish] = useState(false);

  const currentSection = steps?.filter(item => item?.current)[0];
  if (!currentSection) return null;
  // const currentSection = steps[index];

  const { completed, index: currentStep  } = currentSection;
  const { behind, after } = {behind: currentStep - 2, after: currentStep + 2};

  return (
    <div className="step-navigation">
      <div className="step-progress" id="stepProgress">
        {steps?.map((step, index) => {
          
          if(behind <= step?.index && after >= step?.index){
            // console.log(currentStep, step?.index, behind, after)
            return (
              <div
                key={step?.index}
                className={`step-dot ${step?.current  ? 'active' : ''} ${(step?.completed && !step?.current) ? 'completed' : ''}`}
              // data-step={step.id}
              >
                {step?.index}
              </div>
            )
          }else {return null; }
        })}
      </div>
      <div className="step-desc">
        {moduleTitle}
      </div>
      <div className="step-buttons">
        <button
          className="prev-btn"
          // disabled={currentStep === 1}
          onClick={() => exit && exit()}
          // style={{ display: currentStep === 1 ? 'none' : 'inline-block' }}
        >
          Save & Exit
        </button>
        <button
          className="prev-btn"
          disabled={currentStep === 1}
          onClick={() => currentStep > 1 && preview(currentStep)}
          style={{ display: currentStep === 1 ? 'none' : 'inline-block' }}
        >
          Previous
        </button>
        <button
          className="next-btn"
          id="nextBtn"
          onClick={() => !completed ? completeAndNext(currentStep) : next(currentStep)}
          disabled={!completed && currentStep !== 1}
          style={{ display: currentStep < steps?.length ? 'inline-block' : 'none' }}
        >
          Next
        </button>
        {(!moduleCompleted) && (
          <button
            className="finish-btn"
            id="finishBtn"
            disabled={!completed}
            style={{ display: currentStep === steps?.length ? 'inline-block' : 'none' }}
            // onClick={() => alert('🎉 Module completed!')}
            onClick={async () => {
              // completed && finish(currentStep)}}
              if(completed){
                setLoadingFinish(true);
                await finish(currentStep);
                setLoadingFinish(false);
              }
            }}

          >
            {loadingFinish ? 
              (
                <img src="/loading.gif" style={{ filter: "brightness(0.5)" }} alt="loading gif" width={20} height={20} />
              ) : "Finish"
            }
          </button>
        )}
      </div>

      <div className="step-progress-bar-wrapper">
        <div
          className="step-progress-bar"
          id="stepProgressBar"
          style={{ width: `${stepProgressWidth}%` }}
        />
      </div>
    </div>
  );
};


// Reading Step Component
const ReadingStep = ({ module }) => {
  // const modules = [
  //   {
  //     icon: "📖",
  //     title: "Why writing online is a long-term career asset",
  //     content: `Publishing your thoughts, ideas, and expertise online is one of the highest ROI investments you can make for your career. Every article you share not only builds your digital footprint but also acts as proof of your abilities, interests, and growth. \n\nOver time, these published pieces become a living portfolio that can open doors to new job opportunities, speaking gigs, consulting offers, and collaborations—sometimes long after you've hit "publish." By consistently writing online, you're creating a public record of your journey, one that keeps working for you even while you sleep.`,
  //     link: "#enroll"
  //   },
  //   {
  //     icon: "🎤",
  //     title: "How to define your writing voice",
  //     content: "Your writing voice is your unique fingerprint as a creator—it's the personality, tone, and perspective that make your words unmistakably yours. Finding this voice is about more than just grammar and style; it's about tapping into your own experiences, values, and quirks. When you're authentic and true to yourself on the page, you naturally attract readers who resonate with your worldview. \n\nDeveloping your voice is a process of experimentation and reflection, but once you find it, writing becomes easier and more rewarding.",
  //     link: "#enroll"
  //   },
  //   {
  //     icon: "💡",
  //     title: "How to brainstorm article ideas that matter to you",
  //     content: `The best article ideas come from topics that genuinely interest you or solve a problem you care about. \n\nBrainstorming is less about forcing yourself to write what's "trendy," and more about noticing patterns in your curiosities, daily work, or challenges you've overcome. Ask yourself what you wish you'd known sooner, what you're learning right now, or what opinions you hold that others might find valuable or even controversial. When your article ideas are rooted in personal relevance, you're far more likely to finish them—and your passion will show on the page.`,
  //     link: "#enroll"
  //   },
  //   {
  //     icon: "📈",
  //     title: "How to track and organize your writing workflow using Notion or Google Sheets",
  //     content: "A smooth writing workflow can be the difference between wishful thinking and actually publishing. \n\nBy using tools like Notion or Google Sheets, you can easily track your blog ideas, organize drafts, set deadlines, and monitor your progress. These platforms allow you to visually map out what stage each article is in—brainstorming, drafting, editing, or ready to publish—so nothing slips through the cracks. With a simple system, you'll free up your brainpower for creativity, reduce overwhelm, and turn writing into a consistent, repeatable habit.",
  //     link: "#enroll"
  //   }
  // ];

  return (

    <section className="intro-section" id="step-1">
      <h2 className="section-title">{module?.title}</h2>
      <div className="all-modules-card" style={{ textAlign: "start" }}>
        <h2>📝 Description</h2>
        <p>{module?.description}</p>

        <hr style={{
          border: 'none',
          borderTop: '1px solid var(--hn-white)',
          margin: '2rem 0'
        }} />
        {module?.learningPoints && (
          <div className='intro-learning'>
            <h2>📚 What you'll learn in this module</h2>
            <ul>
              {module?.learningPoints.map((learningPoint, idx) => (
                <React.Fragment key={idx}>
                  <li>{learningPoint}</li>
                  {idx < module?.learningPoints?.length - 1 && <br />}
                </React.Fragment>
              ))}
            </ul>
          </div>
        )}

        <div className="all-modules-content">
          {module?.goals?.map((item, i) => (
            <div className="all-modules-text" key={i}>
              <hr style={{
                border: 'none',
                borderTop: '1px solid var(--hn-green)',
                margin: '0 0 2rem 0'
              }} />
              <h3>🚀 Goal {i + 1}: {item}</h3>
            </div>
          ))}
        </div>
      </div>

      <div className="all-modules-card" style={{ textAlign: "start" }}>
        <h2>📢 Please Note</h2>
        <p>Some steps, like <strong>watching the videos</strong> or <strong>answering the quizzes</strong>, must be finished before you can click “Next” and move on to the following section.</p>
      </div>
    </section>
  );
};

// MultipleChoice Component
const MultipleChoice = ({ module, path = "", markComplete, completed = false }) => {

  // console.log("multiple choice", completed)
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showFeedback, setShowFeedback] = useState(false);
  const [correctOption, setCorrectOption] = useState();


  const handleAnswerSelect = (option) => {

    setSelectedAnswer(option?._id);
    if(option?.correct === true){
      setCorrectOption(option?._id);
      markComplete();
    }

    setShowFeedback(true);
  };

  const [mainField, id1, secondField, id2] = path?.split(".");
  if(!mainField || !id1 || !secondField || !id2) return null;
  let questionData;
  const items = module[mainField];
  if(items && items?.length > 0){
    const index = items?.findIndex(({_id}) => _id === id1);
    if(index >= 0) {
      const item = items[index];
      if(item && item[secondField] && item[secondField]?.length > 0){
        let questionIndex = item[secondField].findIndex(({_id}) => _id === id2);
        questionData = item[secondField][questionIndex];
      }
    }
  }

  if(!questionData) return null;

  const {question, options} = questionData;

  return (
    <div className="quiz-step step">
      <h3>{question}</h3>
      <div className="quiz-form">
        {options?.map((option, index) => (
          <label
            key={option?._id}
            className={`quiz-option ${selectedAnswer === option?._id
              ? (option?._id === correctOption)
                ? 'correct'
                : 'incorrect'
              : (completed && option?.correct === true) ? "correct" : ""
              }`}
            onClick={() => handleAnswerSelect(option)}
          >
            <input
              type="radio"
              name={`q-${id2}`}
              value={option?.text}
              checked={selectedAnswer === option?.text}
              onChange={() => { }}
              style={{ display: 'none' }}
            />
            <span>{option?.text}</span>
          </label>
        ))}
        {(showFeedback || completed) && (
          <div className="quiz-feedback">
            {(selectedAnswer === correctOption || completed)
              ? '✅ Correct! You may proceed.'
              : '❌ Wrong answer. Try again!'}
          </div>
        )}
      </div>
    </div>
  );
};


const getYouTubeId = (url) => {
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|watch\?.+&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};


const YouTubePlayer = ({ url, onStart, onEnd, width = "560", height = "315" }) => {
  const playerRef = useRef(null);

  useEffect(() => {
    const videoId = getYouTubeId(url);
    if (!videoId) {
      console.error("Invalid YouTube URL");
      return;
    }

    // Load the IFrame Player API script
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName("script")[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    // Initialize the player when API is ready
    const onYouTubeIframeAPIReady = () => {
      playerRef.current = new window.YT.Player(`youtube-player-${videoId}`, {
        videoId,
        events: {
          onStateChange: (event) => {
            if (event.data === window.YT.PlayerState.PLAYING) {
              onStart && onStart();
            }
            if (event.data === window.YT.PlayerState.ENDED) {
              onEnd && onEnd();
            }
          },
        },
      });
    };

    // If API is already loaded, just initialize
    if (window.YT && window.YT.Player) {
      onYouTubeIframeAPIReady();
    } else {
      window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
    }

    return () => {
      if (playerRef.current) {
        playerRef.current.destroy();
      }
    };
  }, [url, onStart, onEnd]);

  const videoId = getYouTubeId(url);
  // console.log("rendering")

  return <div id={`youtube-player-${videoId}`} style={{ width, height }} />;
};

// Videos Step Component
const VideosStep = ({ markComplete, path, videos }) => {
  const videoId = path?.split(".")[1];
  let video;
  if (videoId) {
    const index = videos?.findIndex(item => item?._id === videoId);
    if (index >= 0) {
      video = videos[index];
    }
  }



  const videoRenderer = useMemo(() => {
    return (
      <div className={`video-card `}>
        <YouTubePlayer
          url={video?.url}
          onStart={() => markComplete()}
          onEnd={() => console.log("Video ended!")}
          width="1100px"
          height="600px"
        />
      </div>
    )
  }, [])

  if (!video) return null;

  return (
    // <section className="step" id="step-2">
    <section className="videos-section" id="videos">
      <h2 className="section-title">📺 {video?.title}</h2>

      {videoRenderer}

      <div className="step-message" id="message-step2"></div>
    </section>
  );
};

// Download Card Component
const DownloadCard = ({ _id, title, url, handleClick, clicked, completed = false }) => {
  const icons = ["📝","💡","📄"];
  const min = 0, max = icons?.length - 1;
  const rand = Math.floor(Math.random() * (max - min + 1) + min);
  return(
    <div className="download-card">
      <div className="download-icon">{icons[rand]}</div>
      <div className="download-title">{title}</div>
      {/* <div className="download-desc"></div> */}
      <a
        className="download-btn"
        download={true}
        href={url}
        onClick={() => handleClick(_id)}
        target={"_blank"}
        rel={"noopener noreferrer"}
      >
        Access
      </a>
      {(clicked?.includes(_id) || completed) && (
        <span>Viewed ✅</span>
      )}
    </div>
  )
};

function arraysHaveSameElements(arr1, arr2) {
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((val, i) => val === sorted2[i]);
}

// Downloads Step Component
const Resources = ({resources = [], markComplete, completed = false} ) => {
  const [clicked, setClicked] = useState([]);

  const handleClick = (_id) => {
    const arr = [...clicked];
    if(!arr.includes(_id)){
      arr.push(_id);
      setClicked([...arr]);
      const resourcesIds = resources?.map(({_id}) => _id);
      if(resourcesIds?.length === arr?.length){
        const sameEls = arraysHaveSameElements(resourcesIds, arr);
        if(sameEls){
          markComplete();
        }
      }
    }
  }

  return (
    <section className="step" id="step-3">
      <section className="downloads-section" id="downloads">
        <h2 className="section-title">📂 Download Materials & Resources</h2>
        <div className="downloads">
          {resources?.map((item, index) => (
            <DownloadCard key={index} {...item} handleClick={_id => handleClick(_id)} clicked={clicked} completed={completed}  />
          ))}
        </div>
      </section>
      <div className="step-message" id="message-step3"></div>
    </section>
  );
};


const AssignmentInstructions = ({assignment}) => {
  const instructions = (assignment?.content || "")?.replace(/<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '');

  return (
    <>
      <h2 className="section-title">📝 Assignment: {assignment?.title}</h2>
      <div className="assignment-editor">
          <label><strong>Instructions</strong></label>
          <div>
            <div dangerouslySetInnerHTML={{ __html: instructions }} />
          </div>
      </div>
    </>
  )
}

// Assignment Step Component
const AssignmentStep = (props) => {
  const { assignments = [], path, completed = false, canHitNext, debounceSaveAssignment, moduleNumber } = props;
  const quillRef = useRef(null);
  const editorRef = useRef(null);
  const [assignment, setAssignment] = useState();
  const [charCount, setCharCount] = useState(0);
  const [reached, setReached] = useState(false);

  const REQUIRED = 100;

  useEffect(() => {
    if(charCount >= 100 && !reached){
      // console.log("you can hit next");
      setReached(true);
      canHitNext();
    }

  }, [charCount])


  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      quillRef.current = new Quill(editorRef.current, {
        theme: 'snow',
        placeholder: "Start typing here...",
        modules: {
          toolbar: '#editor-toolbar'
        }
      });

      const id = path?.split(".")[1];
      let item;
      if (id) {
        const index = assignments?.findIndex(obj => obj?._id === id);
        if (index >= 0){ 
          item = assignments[index];
        }
      } 

      if(item){
        setAssignment(item);
      }


      quillRef.current.clipboard.dangerouslyPasteHTML(item?.answer || '');

      const currentText = quillRef?.current?.getText();
      if(currentText?.length - 1 >= REQUIRED){
        setReached(true);
      }
      if(currentText?.length > 0){
        // console.log("setting", currentText)
        setCharCount(currentText?.length - 1);
      }

      quillRef.current.on('text-change', () => {
        const charCount = quillRef.current.getLength();
        const newCount = (charCount - 1) <= 0 ? 0 : charCount - 1;
        setCharCount(newCount);
        const html = editorRef?.current?.querySelector(".ql-editor").innerHTML;
        debounceSaveAssignment(html, item?._id);
      });
    }
  }, [assignments, path, completed]);


// needs auto-save
  return (
    <section className="step" id="step-4">
      <section className="assignment-section" id="assignment">
        <AssignmentInstructions assignment={assignment} />

        <div className="assignment-editor">
          <label><strong>Write your assignment (Rich Text Editor) </strong></label>
          <div id="editor-toolbar">
            <button className="ql-bold"></button>
            <button className="ql-italic"></button>
            <button className="ql-underline"></button>
            <button className="ql-list" value="ordered"></button>
            <button className="ql-list" value="bullet"></button>
            <button className="ql-header" value="2"></button>
            <button className="ql-code-block"></button>
          </div>
          <div id="editor-container" ref={editorRef}></div>
          {/* {charCount <= REQUIRED && ( */}
            <>
              <br />
              <div style={{ display: 'flex', justifyContent: 'space-between'}}  >
                <span>{charCount} characters</span>
                {charCount <= REQUIRED && <span style={{ textAlign: 'right' }}>Not enough words to continue</span>}
              </div>
            </>
          {/* )} */}
        </div>
      </section>
      <div className="step-message" id="message-step4"></div>
    </section>
  );
};

const AssignmentUrl = (props) => {
  const { assignments = [], path, completed = false, canHitNext, debounceSaveAssignment, moduleNumber } = props;
  const [assignment, setAssignment] = useState();
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [isReady, setIsReady] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setUrl(value);
    debounceSaveAssignment(value || "", assignment?._id);

   // Regex to match the two allowed URL patterns with at least 10 chars in the ID
    const regex = /^https:\/\/app\.hackernoon\.com\/(mobile|articles)\/[a-zA-Z0-9-]{10,}$/;
    if (!regex.test(value)) {
      setError('Make sure the url is a draft url or link.');
    } else {
      setError('');
      if(!isReady && !completed){
        canHitNext();
        setIsReady(true);
      }
    }
  };


  useEffect(() => {
      const id = path?.split(".")[1];
      let item;
      if (id) {
        const index = assignments?.findIndex(obj => obj?._id === id);
        if (index >= 0){ 
          item = assignments[index];
        }
      } 

      if(item){
        setAssignment(item);
        setUrl(item?.answer);
      }

  }, [assignments, path]);

// needs auto-save
  return (
    <section className="step" id="step-4">
      <section className="assignment-section" id="assignment">
        <AssignmentInstructions assignment={assignment} />

        <div className='assignment-editor'>
          <label style={{margin: "0px"}}><strong>Enter Draft URL</strong></label>
          <p style={{marginTop: "3px", fontStyle: "italic", fontSize: "14px"}}>
            A valid HackerNoon Draft Url/Link must be entered before continuing.
          </p>
          <input 
            className='url-input' 
            value={url}
            onChange={handleChange}
            type="text" 
            placeholder='https://app.hackernoon.com/article/...'
          />
          {error && <p style={{ color: '#ff5d5d' }}>{error}</p>}
        </div>
      </section>

    </section>
  );
};



const AssignmentPicker = (props) => {
  const {moduleNumber} = props;
  if(moduleNumber !== 3){
    return <AssignmentStep {...props} />
  }else {
    return <AssignmentUrl {...props} />
  }
}

export { ReadingStep, MultipleChoice, VideosStep, Resources, AssignmentStep, AssignmentPicker, StepNavigation }